import React from 'react';
import type { Language } from '../types';
import { getTranslation } from '../utils/translations';

type CopiedMessageKey = 'copied' | 'idCopied' | 'textCopied';

interface CopiedNoticeModalProps {
    isOpen: boolean;
    onClose: () => void;
    messageKey?: CopiedMessageKey;
    language?: Language;
}

const CopiedNoticeModal: React.FC<CopiedNoticeModalProps> = ({
    isOpen,
    onClose,
    messageKey = 'copied',
    language,
}) => {
    const t = (key: Parameters<typeof getTranslation>[1]) => getTranslation(language, key);

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[650] p-4 animate-fade-in"
            onClick={onClose}
        >
            <div
                className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl w-full max-w-xs overflow-hidden border border-white/20 dark:border-slate-800"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="p-6 text-center">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full mb-4 bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400">
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-black text-slate-800 dark:text-slate-100">{t(messageKey)}</h3>
                </div>
                <div className="bg-slate-50 dark:bg-slate-800 p-4">
                    <button
                        type="button"
                        onClick={onClose}
                        className="w-full px-4 py-2.5 bg-slate-900 dark:bg-slate-700 text-white font-bold rounded-xl hover:bg-slate-800 dark:hover:bg-slate-600 transition-all text-sm"
                    >
                        {t('ok')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CopiedNoticeModal;
